﻿import React from 'react';
import IconHelper from '@bazooka_se/lf-icons';

// components

// state
import { connect } from 'react-redux';
import { fetchPreregistrationSummaryData } from './State/actions';

// utils
import * as constants from '../PurchasesStatusTeaser/Utils/constants';
import { getEpiData } from '../../Utils/epiHelpers';


const PurchasesStatusTeaser = (props) => {

    React.useEffect(() => {
        props.loadSummary();
    }, []);

    const summaryData = props.preregistrationSummaries;

    if (!summaryData || !summaryData.length ) {
        return;
    }

    return (
        <>
            <h2 className="purchases-status-teaser__main-title">Påbörjade köp</h2>
            {summaryData.map((data, index) => (
                <StatusTeaser key={index} status={data.status} title={data.productDisplayName} date={data.fromDate} props={props} />
            ))}
        </>       
    )
        
};

function formatDate(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

const StatusTeaser = ({ status, title, date, props }) => {
    const { text, infoText, linkText } = getTexts(status);
    const formattedDate = formatDate(date);
    let link = getEpiData('teaser-target', props.mountRootId) || '';
    link = `/${link}` || "";

    return (
        <div className={`purchases-status-teaser purchases-status-teaser__${status} block-spacing`}>
            <h3 className="purchases-status-teaser__title">{title}</h3>
            <p className="purchases-status-teaser__text">{text}</p>
            <p className="purchases-status-teaser__date"><strong>Önskat startdatum:</strong> {formattedDate}</p>
            <div className={`purchases-status-teaser__flex-container ${status === 'pending-terms' ? 'purchases-status-teaser__flex-container__button' : ''}`} >
                <p className="purchases-status-teaser__info-text">{infoText}</p>
                {status === 'pending-terms' ? (
                    <a
                        className="purchases-status-teaser__link button"
                        href={link}
                    >
                        {linkText}
                        <span className="purchases-status-teaser__link__icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('external-link').outerHTML }}>
                        </span>
                    </a>
                ) : (
                    <>
                        <span className="purchases-status-teaser__icon"
                            dangerouslySetInnerHTML={{ __html: IconHelper('clock').outerHTML }}>
                        </span>
                    </>
                )}
            </div>
        </div>
    );
}

function getTexts(status) {
    switch (status) {
        case 'pending-terms':
            return {
                text: `${ constants.pendingTerms.text }`,
                infoText: `${constants.pendingTerms.infoText}`,
                linkText: `${constants.pendingTerms.linkText}`,
            }
        case 'risk':
            return {
                text: `${constants.risk.text}`,
                infoText: `${constants.risk.infoText}`
            }
        case 'processing':
            return {
                text: `${constants.processing.text}`,
                infoText: `${constants.processing.infoText}`
            }
        default:
            return {
                text: `${constants.defaultText.text}`,
                infoText: `${constants.defaultText.infoText}`,
                linkText: `${constants.defaultText.linkText}`,
            }
    }
}

const mapStateToProps = (state) => {
    return {
        preregistrationSummaries: state.preregistrationSummary.preregistrationSummaries,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        loadSummary: (preregistrationSummaries) => dispatch(fetchPreregistrationSummaryData(preregistrationSummaries)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchasesStatusTeaser);

